import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../../shared/services/language.service';

@Component({
  selector: 'app-promocode-modal',
  templateUrl: './promocode-modal.component.html',
  styleUrls: ['./promocode-modal.component.scss']
})
export class PromocodeModalComponent implements OnInit {
  isReadOnly: boolean = true;
  promocode: string = '';

  constructor(
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<PromocodeModalComponent>,
    public translate: TranslateService,
    private languageService: LanguageService
  ) { }

  ngOnInit() {
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
    this.promocode = this.data.name;
  }

  copyInputMessage(inputElement: any) {
    this.dialogRef.close(true);
    inputElement.select();
    document.execCommand('copy');
    inputElement.setSelectionRange(0, 0);
    this.snackBar.open('Your promo code copied to clipboard', '', { duration: 3000 });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
